<template>
  <div class="votemain">
    <van-tabs title-active-color="#FF6C1A" color="#fff" v-model="active" @click="onClickTab">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.title" :name="item.name">
        <van-pull-refresh v-model="loading" @refresh="onRefresh">

          <!-- <div v-if="loading" style="
            width: 100%;
            height: 100%;
            text-align: center;
            margin-top: 200px;
          ">
            <van-loading size="30px">加载中...</van-loading>
          </div> -->
          <div class="voteListBox">
            <!-- <voteItem :active="active"></voteItem> -->
            <div class="full">
              <div v-if="dataList.length > 0">
                <div class="voteBox" v-for="(item, index) in dataList" :key="index" @click="getInfo(item)">
                  <div class="time">
                    距离投票结束还剩:
                    <span>
                      <van-count-down :time="item.time" format="DD 天 HH 时 mm 分" />
                    </span>

                  </div>
                  <div class="voteName">
                    <img src="../../assets/img/ico_toupiao.png" alt="" />
                    <div class="name">{{ item.tpmc }}</div>
                  </div>

                  <div class="voteBottom">
                    <div class="voteIn">
                      <img src="../../assets/img/ico_renshu.png" alt="" />
                      <span>参与:{{ item.tprs }}人</span>
                    </div>

                    <div class="VoteType">{{ item.tplx | title }}</div>

                    <van-button v-if="item.grtpzt == 1 || item.grtpzt == 2" :disabled="item.grtpzt == 2"
                      color="#ff6c19">
                      {{ item.grtpzt | btn }}
                    </van-button>




                    <van-button v-else disabled color="#BABABA">
                      {{ item.grtpzt | btn }}
                    </van-button>



                  </div>
                </div>
              </div>
              <div v-if="!dataList.length && !loading">
                <noData></noData>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-tab>

      <van-tab>
        <template #title>
          <van-icon name="filter-o" />筛选
        </template>
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
          <div class="voteListBox">
            <!-- <voteItem :active="active"></voteItem> -->
            <div class="full">
              <div v-if="dataList.length > 0">
                <div class="voteBox" v-for="(item, index) in dataList" :key="index" @click="getInfo(item)">
                  <div class="time">
                    距离投票结束还剩:
                    <span>
                      <van-count-down :time="item.time" format="DD 天 HH 时 mm 分" />
                    </span>

                  </div>
                  <div class="voteName">
                    <img src="../../assets/img/ico_toupiao.png" alt="" />
                    <div class="name">{{ item.tpmc }}</div>
                  </div>

                  <div class="voteBottom">
                    <div class="voteIn">
                      <img src="../../assets/img/ico_renshu.png" alt="" />
                      <span>参与:{{ item.tprs }}人</span>
                    </div>

                    <div class="VoteType">{{ item.tplx | title }}</div>

                    <van-button v-if="item.grtpzt == 1 || item.grtpzt == 2" :disabled="item.grtpzt == 2"
                      color="#ff6c19">
                      {{ item.grtpzt | btn }}
                    </van-button>




                    <van-button v-else disabled color="#BABABA">
                      {{ item.grtpzt | btn }}
                    </van-button>



                  </div>
                </div>
              </div>
              <div v-if="!dataList.length && !loading">
                <noData></noData>
              </div>
            </div>
          </div>
        </van-pull-refresh>

      </van-tab>
    </van-tabs>

    <van-popup v-model="showSerach" position="top">
      <div class="popBox">
        <span>投票意见</span>
        <div class="tagBox">
          <van-tag v-for="(item, index) in voteTypeList" :key="'type_' + index" :color="
            params.tpyj == item.val ? '#FF6C1A' : '#F7F7F7'
          " :text-color="params.tpyj == item.val ? '#FF6C1A' : '#999998'" @click="chageTypeTag(item.val)" plain
            type="primary" size="large">{{ item.name }}</van-tag>
        </div>

        <span>投票状态</span>
        <div class="tagBox">
          <van-tag v-for="(item, index) in voteStatusList" :key="'type_' + index" :color="
            (params.tpzt == item.val) != 0 && item.val ? '#FF6C1A' : '#F7F7F7'
          " :text-color="params.tpzt == item.val ? '#FF6C1A' : '#999998'" @click="chageStatusTag(item.val)" plain
            type="primary" size="large">{{ item.name }}</van-tag>
        </div>

        <div class="buttonBox">
          <button class="reset" @click="reset()">重置</button>
          <button class="sure" @click="sure()">确认</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import voteItem from "../components/voteItem.vue";
import noData from "../components/noData.vue"
import api from '@/api/vote.js'
export default {
  components: {
    voteItem, noData
  },
  data() {
    return {
      time: 30 * 60 * 60 * 1000,
      active: "",
      showSerach: false,
      dataList: [],
      tabs: [
        {
          title: "全部",
          name: "",
        },
        {
          title: "使用投票",
          name: 1,
        },
        {
          title: "验收投票",
          name: 2,
        },
      ],
      loading: true,
      voteTypeList: [
        { name: "全部", val: 0 },
        { name: "同意", val: 1 },
        { name: "不同意", val: 2 },
        { name: "弃票", val: 3 },


      ],
      voteStatusList: [
        { name: "全部", val: -1 },
        { name: "进行中", val: 1 },
        { name: "已发布", val: 0 },
        { name: "已结束 ", val: 2 },
      ],
      wyqyId: '',
      params: {
        tplx: "",
        tpzt: -1,
        tpyj: 0

      }
    };
  },
  mounted() {
    this.getList()
  },
  filters: {
    title(val) {
      if (val == 0 || val == 1) {
        return "使用投票"
      } else {
        return "验收投票"
      }
    },
    btn(val) {
      let msg = ''
      switch (val) {
        case 0:
          msg = '未开始'
          break;
        case 1:
          msg = "我要投票"
          break;
        case 2:
          msg = "已投票"
          break;
        case 3:
          msg = "已结束"
          break;
        default:
          msg = '未开始'
          break;
      }

      return msg
    }

  },
  created() {
    this.wyqyId = Number(sessionStorage.getItem('wyqy'))
  },
  methods: {
    onClickTab(title) {

      console.log('111', title)

      if (title == 3) {
        this.showSerach = true;

      } else {
        this.params.tplx = title

        this.getList()
      }

      console.log('active', this.active)
      console.log('params.tplx', this.params.tplx)

    },
    onRefresh() {
      this.loading = false
      this.getList()
    },
    /**
    * 列表
    */
    getList() {
      console.log('获取')
      let params = {
        openId: sessionStorage.getItem('openId'),
        tplx: this.params.tplx,
        tpzt: this.params.tpzt,
        tpyj: this.params.tpyj,
        wyqyId: this.wyqyId,
        fwId: sessionStorage.getItem('fwId'),
      }
      this.loading = true;
      this.dataList = []
      api.voteList(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data
          this.dataList.forEach(item => {
            let toDay = new Date().getTime()
            let end = new Date(item.tpjssj).getTime()
            item.time = end - toDay
          })
          if (this.dataList.length > 0) {
            this.loading = false;
          } else {
            this.loading = false;

          }
        } else {
          this.loading = false;
        }
      }).catch(err => {
        this.loading = false;
        this.$toast.fail({
          message: err,
        })
      })
    },
    /**
     * 重置筛选条件
     */
    reset() {
      this.params.tpyj = 0
      this.params.tpzt = -1
      this.params.tplx = ''
      let params = {
        openId: sessionStorage.getItem('openId'),
        tplx: this.params.tplx,
        tpyj: this.params.tpyj,
        tpzt: this.params.tpzt,
        wyqyId: this.wyqyId,
        fwId: sessionStorage.getItem('fwId'),
      }
      this.showSerach = false;
      api.voteList(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data
        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },
    /**
     * 确定筛选条件
     */
    sure() {
      this.showSerach = false;
      let params = {
        openId: sessionStorage.getItem('openId'),
        tplx: this.params.tplx,
        tpzt: this.params.tpzt,
        tpyj: this.params.tpyj,
        wyqyId: this.wyqyId,
        fwId: sessionStorage.getItem('fwId'),
      }
      api.voteList(params).then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data
          this.dataList.forEach(item => {
            let toDay = new Date().getTime()
            let end = new Date(item.tpjssj).getTime()
            item.time = end - toDay
          })
        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },
    /**
    * 投票详情
    */
    getInfo(item) {
      if (item.grtpzt == 0) {
        this.$toast.fail({
          message: '投票暂未开始',
        })
        return
      } else {
        location.href = '/detail' + '?id=' + item.id + '&tplx=' + item.tplx + '&fwId=' + item.fwId

        // this.$router.push({ path: '/detail', query: { id: item.id, tplx: item.tplx, fwId: item.fwId } })

      }
    },
    chageTypeTag(val) {
      this.params.tpyj = val
    },
    chageStatusTag(val) {
      this.params.tpzt = val;
    },

  },
  watch: {},
};
</script>

<style lang="less" scoped>
.van-count-down {
  display: inline-block;
  color: #ff6c19;
  width: 120px;
}

.votemain {
  background: #f4f7f9;
  height: 100%;
}

.voteListBox {
  min-height: 100vh;
  background: #f4f7f9;

  padding: 0 16px;
  padding-bottom: 60px;
}



/deep/.van-tabs__wrap {
  position: sticky;
  z-index: 9999;
  top: 0;
}

.popBox {
  margin-top: 25px;
  padding: 20px;

  .tagBox {
    margin: 16px 0;

    .van-tag {
      margin: 0 10px;
    }
  }

  .buttonBox {
    display: flex;

    button {
      height: 44px;
      text-align: center;
      border: none;
      border-radius: 22px;
      font-size: 16px;

      &.reset {
        flex: 1;
        color: #ff6c1a;
        border: 1px solid #ff6c1a;
        background-color: #fff;
      }

      &.sure {
        margin-left: 20px;
        flex: 2;
        border: 1px solid #ff6c1a;
        color: #fff;
        background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
      }
    }
  }
}

.voteBox {
  width: 100%;
  background: #fff;
  margin-top: 20px;
  border-radius: 3px;
  padding-bottom: 16px;

  &::after {
    content: "";
    display: block;
    height: 0;
    width: 0;
    clear: both;
  }

  .time {
    width: 244px;
    height: 30px;
    background: linear-gradient(96deg, #ffd8c1 0%, #fff6f1 100%);
    border-radius: 8px 0 24px 0px;
    font-size: 12px;
    color: #ff6c1a;
    padding-left: 12px;
    line-height: 30px;

    span {
      color: #ff6c1a;
      font-size: 15px;
      font-weight: bold;
      padding: 0 3px;
    }
  }

  .voteName {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;

    img {
      display: block;
      width: 22px;
      height: 22px;
    }

    .name {
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-left: 3px;
      min-height: 21px;
      color: #222120;
      font-weight: bold;
    }
  }

  .voteBottom {
    padding: 0 16px;
    margin-top: 20px;

    button {
      padding: 0 17px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #ff6c1a;
      color: #fff;
      border-radius: 30px;
      float: right;
      border: none;
      font-size: 13px;
    }

    .voteIn,
    .VoteType {
      display: inline-block;
      font-size: 13px;
      line-height: 30px;
      padding: 0 5px;
      border-radius: 3px;
    }

    .voteIn {
      background: #f7f7f7;
      color: #6b6a6a;
      border: 1px solid #e9e9e9;
      letter-spacing: 1px;

      img {
        // margin-top: 5px;
        margin-top: 6px;
        margin-right: 5px;
        float: left;
        width: 16px;
        height: 16px;
      }
    }

    .VoteType {
      color: #00c797;
      background: rgba(0, 199, 151, 0.05);
      border: 1px solid #00c797;
      margin-left: 5px;
    }
  }
}
</style>
